import { render, staticRenderFns } from "./cg-postarequirePopup.vue?vue&type=template&id=cc06f22c"
import script from "./cg-postarequirePopup.vue?vue&type=script&lang=js"
export * from "./cg-postarequirePopup.vue?vue&type=script&lang=js"
import style0 from "./cg-postarequirePopup.vue?vue&type=style&index=0&id=cc06f22c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports